<template>
    <OrderDetails/>
</template>
<script>
import OrderDetails from '../../components/orders/OrderDetails';

export default {
  components: {
    OrderDetails,
  },
};
</script>
